import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";

const DQCPLayout = () => {
  const [documentsPDFPath, setDocumentsPDFPath] = useState<string>("");

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig setDocumentsPDFPath={setDocumentsPDFPath} />
        <AOPPrev documentsPDFPath={documentsPDFPath} />
      </div>
    </>
  );
};

export default DQCPLayout;
